import {
	CreateUpdateSensorGroupFormValues,
	ListSensorGroupsParams,
	SensorGroupPair,
	SensorGroupPairRequest,
	PaginatedSensorGroupPairs,
} from '@Types/sensorGroup.types';

import sensorGroup from '@Apis/sensorGroup.api';

const SENSOR_GROUP_TIMEOUT = 10000;

export const getSensorGroupsService = (params?: ListSensorGroupsParams) =>
	sensorGroup.get('/sensor-groups', {
		params,
		timeout: SENSOR_GROUP_TIMEOUT,
	});

// eslint-disable-next-line prettier/prettier
export const getSingleSensorGroup = (id: string) => sensorGroup.get(`/sensor-group-config/${id}`, {
		params: {
			includeSensorGroupPairs: 'true',
			timeout: SENSOR_GROUP_TIMEOUT,
		},
	});

export const upsertSensorGroupService = (
	params?: CreateUpdateSensorGroupFormValues,
) => {
	const body: { name?: string; sensorType?: string; _id?: string } = {
		name: params?.name,
		sensorType: params?.sensorType,
	};
	if (params?._id) body['_id'] = params?._id;
	return sensorGroup.put('/sensor-group-config ', body, {
		timeout: SENSOR_GROUP_TIMEOUT,
	});
};

export const createSensorGroupPair = (params: SensorGroupPairRequest) => {
	return sensorGroup.put<{
		sensorConfigPairs: SensorGroupPair[];
	}>(
		'/sensor-group-pairs',
		{
			sensorGroupConfig: params.sensorGroupConfig,
			sensors: params.sensors,
		},
		{ timeout: SENSOR_GROUP_TIMEOUT },
	);
};

export const deleteSensorGroupPair = (id: SensorGroupPairRequest) =>
	sensorGroup.delete<{
		sensorConfigPairs: SensorGroupPair[];
	}>('/sensor-group-pairs', {
		data: {
			sensorGroupConfig: id.sensorGroupConfig,
			sensors: id.sensors,
		},
		timeout: SENSOR_GROUP_TIMEOUT,
	});

// eslint-disable-next-line prettier/prettier
export const deleteSensorGroupService = (id: string) =>
	sensorGroup.delete<{
		sensorConfigPairs: SensorGroupPair[];
	}>(`/sensor-group/${id}`, {
		params: { deleteSensorGroupPairs: true },
	});

// eslint-disable-next-line prettier/prettier
export const getSensorGroupPairService = (id: string) => sensorGroup.get<PaginatedSensorGroupPairs>('/sensor-group-pairs', {
		params: { sensorGroupConfig: id, limit: 100 },
		timeout: SENSOR_GROUP_TIMEOUT,
	});

export async function deleteSensorGroupPairService(
	action: SensorGroupPairRequest,
) {
	try {
		const sensorConfigPairResponse = await deleteSensorGroupPair(action);
		if (sensorConfigPairResponse.data) {
			return 'success';
		} else {
			return 'error';
		}
	} catch (e) {
		console.error(e);
		return 'error';
	}
}

export async function createSensorGroupPairService(
	action: SensorGroupPairRequest,
) {
	try {
		const sensorConfigPairResponse = await createSensorGroupPair(action);
		if (sensorConfigPairResponse.data) {
			return 'success';
		} else {
			return 'error';
		}
	} catch (e) {
		console.error(e);
		return 'error';
	}
}
